import { onChildAdded, orderByChild, query, startAt } from '@/features/firebase/adapter/database'
import FirebaseDatabaseRefService from '@/features/firebase/services/database-ref'
import { Notification } from '@/features/notifications/notification-service-extension-shared/types/app'
import { transformNotification } from '@/features/notifications/notification-service-extension-shared/utils/transforms'
import dayjs from 'dayjs'
import invariant from 'tiny-invariant'

export const listenFirebaseRecentNotification = (
    callback: (notification: Notification) => Promise<void>
): (() => void) => {
    const initialTime = dayjs()

    return onChildAdded(
        query(
            FirebaseDatabaseRefService.notifications(),
            orderByChild('createdAt'),
            startAt(initialTime.unix())
        ),
        async (snapshot) => {
            invariant(snapshot.key, "Snapshot key doesn't exist")

            const notification = transformNotification(snapshot.val())

            if (!notification) return

            await callback(notification)
        }
    )
}
